import { Component, OnInit, Output, EventEmitter, OnDestroy, HostListener } from '@angular/core';
import { CoreService, HttpService } from '../services';
import { DialogService } from '../dialog/dialog.service';
import { AgendaModel, BObjectModel, BreadcrumbModel, DateModel, SelectAgenda, QueovalDik, DayDisplay } from '../models';
import { Subscription } from 'rxjs';
import { PadLeft } from '../utilities';
import { NgbDateStruct, NgbCalendar, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { AgendaQueovalService } from './agenda.queoval.services';
import { I18n, CustomDatepickerI18n } from '../bodisplay/dynamictag/dynamictag-addon/datepicker/datepicker.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-agenda',
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.css'],
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }] // define custom NgbDatepickerI18n provide
})

export class AgendaComponent implements OnInit, OnDestroy {
  private sub: Subscription;
  private DREF: string = '';
  private listAgendaTypes: string = '';

  public arrayFormat: QueovalDik[] = [
    { key: '1J', value: '1 jour' },
    { key: '5J', value: '5 jours' },
    { key: '6J', value: '6 jours' },
    { key: '7J', value: '7 jours' },
    { key: '1M', value: '1 mois(7 jours)' },
    { key: '1W', value: '1 mois(5 jours)' },
  ];
  public modeAgenda: string = '';
  public connectedUserImage: string = '';
  public connectedUserName: string = '';
  public DataAgenda: AgendaModel;
  public type: string = 'W';
  public model: BObjectModel;
  public modeAffiche: string;
  public datePickerModel: NgbDateStruct;

  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();


  public isLargeScreen: boolean = window.innerWidth >= 768;
  @HostListener('window:resize', ['$event'])
  onResize(event?: Event): void {
    this.isLargeScreen = window.innerWidth >= 768;
  }

  constructor(
    public indParam: CoreService,
    private http: HttpService,
    private dialogservice: DialogService,
    private calendar: NgbCalendar,
    private agendaService: AgendaQueovalService
  ) { }


  ngOnInit(): void {
    // get the agenda mode eventually stocked in localStorage
    this.modeAgenda = this.getStorageKey('ModeAgenda');
    if (this.modeAgenda === '' || this.modeAgenda.length > 2) {
      this.modeAgenda = '7J';
      localStorage.setItem('ModeAgenda', '7J');
    }
    // get the agenda types eventually stocked in localStorage
    this.listAgendaTypes = this.getStorageKey('ListAgenda');
    // get eventual agenda's owner from queryString
    if (!this.agendaService.BreadCrumbBack()) {
      this.agendaService.UserAgendaID = this.indParam.CurrentUrl.GetQueryParam('IdPersonne');
    }
    // set datepicker to TODAY

    this.datePickerModel = this.agendaService.BreadCrumbBack() && this.agendaService.CalendarDate
      ? this.agendaService.CalendarDate
      : this.calendar.getToday();

    setTimeout(() => {
      $("select.custom-select[aria-label*='year']").val(this.datePickerModel.year);
      $("select.custom-select[aria-label*='month']").val(this.datePickerModel.month);
    }, 0);

    this.RefreshAgenda('N');
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }


  public isDisabled = (date: NgbDateStruct, current: { month: number }): boolean => {
    return date.month !== current.month;
  }

  public selectAgendaType(move: string): void {
    // move can be equal (|T pour revenir a today) (|S pour la periode suivante) (|P pour la periode precedente) (|N pour neutre)
    this.ReloadAgenda(move);
  }

  public ReloadAgenda(move: string): void {
    this.RefreshAgenda(move);
  }

  public onSelectPicker(e: any): void {
    const changedDate: DateModel = e as DateModel;
    //if (changedDate) {
    //#region calcul lundi, vendredi, samedi et dimanche à partir de la date sélectionnée + date précédente à partir de la DREF
    const previousDate: Date = new Date(Number(this.DREF.slice(0, 4)), Number(this.DREF.slice(4, 6)) - 1, Number(this.DREF.slice(6, 8)));
    const currentDate: Date = new Date(Number(changedDate.year), Number(changedDate.month) - 1, Number(changedDate.day));
    const day: number = currentDate.getDay();
    const diff: number = currentDate.getDate() - day + (day === 0 ? -6 : 1);
    const monday: Date = new Date(currentDate.setDate(diff));
    const sunday: Date = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
    // #endregion
    const sameMonthInModeMonth: boolean = (this.type === 'M' && this.DREF.slice(0, 6) === `${changedDate.year}${PadLeft(changedDate.month, 2)}`);
    const sameWeekInModeWeek: boolean = (this.type === 'W' && this.modeAgenda !== '1J' && previousDate >= monday && previousDate <= sunday);
    const sameDayInMode1J: boolean = (this.modeAgenda === '1J' && previousDate === currentDate);

    const dd: string = changedDate.day ? PadLeft(changedDate.day, 2) : '01';
    const mm: string = changedDate.month ? PadLeft(changedDate.month, 2) : '01';
    const yy: string = changedDate.year ? `${changedDate.year}` : '0001';
    const NewDREF: string = yy + mm + dd;
    if (this.DREF !== NewDREF) {
      this.DREF = NewDREF;

      if (!sameMonthInModeMonth && !sameWeekInModeWeek && !sameDayInMode1J) {
        this.RefreshAgenda('T');
      }
      // }
    } else {
      const DREFyy: number = parseInt(this.DREF.substring(0, 4));
      const DREFmm: number = parseInt(this.DREF.substring(4, 6));
      const DREFdd: number = parseInt(this.DREF.substring(6, 8));
      this.datePickerModel = { year: DREFyy, month: DREFmm, day: DREFdd };
      this.agendaService.StringifiedCalendarDate = JSON.stringify(this.datePickerModel);
    }
  }

  public changeDisplayMode(): void {
    this.modeAgenda = this.modeAgenda;
    localStorage.setItem('ModeAgenda', this.modeAgenda);
    this.RefreshAgenda('N');
  }

  public getBreadcrumb(breadcrumb: BreadcrumbModel): void {
    // this calls a "getBreadcrumb" method on the parent page
    this.sendBreadcrumb.emit(breadcrumb);
  }


  private RefreshAgenda(move: string): void {
    this.dialogservice.showSplash(true);

    if (this.DataAgenda) {
      this.listAgendaTypes = this.DataAgenda
        ? this.DataAgenda.ListAgenda.filter((ag1: SelectAgenda) => ag1.Check).map((ag2: SelectAgenda) => ag2.Code).join(',')
        : '';
    }
    localStorage.setItem('ListAgenda', this.listAgendaTypes);

    this.type = this.modeAgenda === '1M' || this.modeAgenda === '1W' ? 'M' : 'W';

    const date: DateModel = new DateModel();
    if (this.agendaService.BreadCrumbBack() && this.agendaService.CalendarDate) {
      date.year = this.agendaService.CalendarDate.year;
      date.month = this.agendaService.CalendarDate.month;
      date.day = this.agendaService.CalendarDate.day;
    }

    this.DREF = this.DREF === '' && date
      ? `${date.year}${PadLeft(date.month, 2)}${PadLeft(date.day, 2)}`
      : this.DREF;

    const url: string = `${this.indParam.AppParams.apiUrl}api/Agenda/getData/INITDATA/${this.modeAgenda}|${move}|${this.DREF}|${this.listAgendaTypes}|${this.agendaService.UserAgendaID}`;
    this.sub = this.http.getHttp<AgendaModel>(url).subscribe((data: AgendaModel) => {
      if (!data.HasError) {
        setTimeout(() => {
          this.connectedUserImage = data.ConnectedUserImage;
          this.connectedUserName = data.Title;
          this.DataAgenda = data;

          this.DREF = this.DataAgenda.DREF;

          const yy: number = parseInt(this.DREF.substring(0, 4));
          const mm: number = parseInt(this.DREF.substring(4, 6));
          const dd: number = parseInt(this.DREF.substring(6, 8));
          this.datePickerModel = { year: yy, month: mm, day: dd };
          this.agendaService.StringifiedCalendarDate = JSON.stringify(this.datePickerModel);
        }, 0);
      }
      this.dialogservice.showSplash(false);
    });
  }

  private getStorageKey(key: string): string {
    const dt: string | null = localStorage.getItem(key);
    return dt ? dt : '';
  }
}

//export class AgendaComponent implements OnInit, OnDestroy {

//  public connectedUserImage: string = '';
//  public connectedUserName: string = '';
//  public DataAgenda: AgendaModel;
//  public type: string = 'W';
//  public model: BObjectModel;
//  public modeAffiche: string;
//  public showAffiche: boolean;

//  public tablette: boolean;
//  public mobile: boolean;

//  private userAgenda: string = '';
//  private DREF: string = '';
//  private listAgenda: string = '';
//  private modeAgenda: string = '';
//  private sub: Subscription;

//  @ViewChild(SelectComponent) selectcomponent?: SelectComponent;
//  @Output() sendBreadcrumb: EventEmitter<BreadcrumbModel> = new EventEmitter<BreadcrumbModel>();
//  @HostListener('window:click', ['$event'])
//  onClick(event: any): void {
//    if (this.selectcomponent) {
//      if (event.target.getAttribute('datepicker') !== 'datepicker' || event.target.getAttribute('datepicker') === null) {
//        this.selectcomponent.selectPicker(this.DREF);
//      }
//    }
//  }
//  @HostListener('window:resize', ['$event'])
//  onResize(event?: Event): void {
//    this.tablette = window.innerWidth <= 1200 && window.innerWidth > 768 ? true : false;
//    this.mobile = window.innerWidth <= 768 ? true : false;
//  }


//  constructor(
//    private indParam: CoreService,
//    private http: HttpService,
//    private dialogservice: DialogService,
//    private breadcrumbService: BreadcrumbService
//  ) {}



//  ngOnInit(): void {
//    this.userAgenda = this.indParam.CurrentUrl.GetQueryParam('IdPersonne');

//    this.showAffiche = true;
//    this.modeAgenda = this.getStorageKey('ModeAgenda');
//    this.listAgenda = this.getStorageKey('ListAgenda');

//    //const modeAgenda: string | null = localStorage.getItem('ModeAgenda');
//    //if (modeAgenda !== null) {
//    //  this.modeAgenda = modeAgenda;
//    //}
//    //const listAgenda: string | null = localStorage.getItem('ListAgenda');
//    //if (listAgenda !== null) {
//    //  this.listAgenda = listAgenda;
//    //}
//    if (this.modeAgenda === '' || this.modeAgenda.length > 2) {
//      this.modeAgenda = '7J';
//      localStorage.setItem('ModeAgenda', '7J');
//    }
//    //else {
//    //  if (this.modeAgenda.length > 2) {
//    //    this.modeAgenda = '7J';
//    //    localStorage.setItem('ModeAgenda', '7J');
//    //  }
//    //}
//    this.RefreshAgenda('N');
//  }

//  public ngOnDestroy(): void {
//    this.sub.unsubscribe();
//  }


//  // 2 parametres  (S pour la periode suivante) (P pour la periode precedente)
//  public ReloadAgenda(Move: string): void {
//    // dans ce cas le modeagenda n'est pas enregistre dans le locagestorage
//    this.RefreshAgenda(Move);
//  }

//  // parametre est egale a T mais pas d'importance
//  public MoveDay(MoveDate: DateModel): void {
//    let day: string = '01';
//    if (MoveDate.day !== undefined) {
//      day = MoveDate.day.toString();
//    }
//    if (day.length < 2) {
//      day = '0' + day;
//    }
//    const monthdec: number = MoveDate.month;
//    let month: string = monthdec.toString();
//    if (month.length < 2) {
//      month = '0' + month;
//    }
//    const NewDREF: string = MoveDate.year.toString() + month + day;
//    if (this.DREF !== NewDREF) {
//      this.DREF = NewDREF;
//      this.RefreshAgenda('T');
//    }
//  }

//  public ChangeMode(modeAgenda: string): void {
//    this.modeAgenda = modeAgenda;
//    localStorage.setItem('ModeAgenda', this.modeAgenda);
//    this.RefreshAgenda('N');
//  }

//  public ListDay(DAYREF: string): void {
//    const newDate: Date = new Date(DAYREF);
//    let day: string = newDate.getDate().toString();
//    if (day.length < 2) {
//      day = '0' + day;
//    }
//    let monthdec: number = newDate.getMonth();
//    monthdec++;
//    let month: string = monthdec.toString();
//    if (month.length < 2) {
//      month = '0' + month;
//    }
//    // const NewDREF = newDate.getFullYear().toString() + month + day;
//    // this.RefreshListDay(NewDREF);
//  }


//  private RefreshAgenda(move: string): void {
//    this.dialogservice.showSplash(true);

//    //if (this.DataAgenda) {
//      //let result: string = '';
//      //for (let i: number = 0; i < this.DataAgenda.ListAgenda.length; i++) {
//      //  const element: SelectAgenda = this.DataAgenda.ListAgenda[i];
//      //  if (element.Check) {
//      //    if (result.length === 0) {
//      //      result = element.Code;
//      //    } else {
//      //      result = result + ',' + element.Code;
//      //    }
//      //  }
//      //}
//      //this.listAgenda = result;
//    //}

//    this.listAgenda = this.DataAgenda
//      ? this.DataAgenda.ListAgenda.filter((ag1: SelectAgenda) => ag1.Check).map((ag2: SelectAgenda) => ag2.Code).join(',')
//      : '';
//    localStorage.setItem('ListAgenda', this.listAgenda);

//    //switch (this.modeAgenda) {
//    //  case '1M':
//    //  case '1W':
//    //    this.type = 'M';
//    //    break;
//    //  default:
//    //    this.type = 'W';
//    //    break;
//    //}
//    this.type = this.modeAgenda === '1M' || this.modeAgenda === '1W' ? 'M' : 'W';

//    let date: DateModel = new DateModel();
//      // regarde dans les params du breadcrumb si la page est appelée depuis une page enfant
//    const navigFromChild: boolean = this.breadcrumbService.Breadcrumb[this.breadcrumbService.Breadcrumb.length - 1].data.params.filter((el: BreadDik) => el.key === 'childFrom').length > 0;
//    if (navigFromChild) {
//      const lsd: string | null = localStorage.getItem('date');
//      if (lsd) { date = JSON.parse(lsd); }
//    }

//    //if (this.DREF === '' && date) {
//    //  const month: string = date.month < 10 ? `0${date.month}` : `${date.month}`;
//    //  const day: string = date.day < 10 ? `0${date.day}` : `${date.day}`;
//    //  this.DREF = `${date.year}${month}${day}`;
//    //}
//    this.DREF = this.DREF === '' && date
//      ? `${date.year}${PadLeft(date.month, 2)}${PadLeft(date.day, 2)}`
//      : this.DREF;

//    const url: string = `${this.indParam.AppParams.apiUrl}api/Agenda/getData/INITDATA/${this.modeAgenda}|${move}|${this.DREF}|${this.listAgenda}|${this.userAgenda}`;
//    this.sub = this.http.getHttp<AgendaModel>(url).subscribe((data: AgendaModel) => {
//      if (!data.HasError) {
//        setTimeout(() => {
//          this.connectedUserImage = data.ConnectedUserImage;
//          this.connectedUserName = data.Title;
//          this.DataAgenda = data;
//          this.DREF = this.DataAgenda.DREF;
//          if (this.selectcomponent) {
//            this.selectcomponent.selectPicker(this.DREF);
//          }
//        }, 0);
//      }
//      this.dialogservice.showSplash(false);
//    });
//  }

//  getBreadcrumb(breadcrumb: BreadcrumbModel): void {
//    // this calls a "getBreadcrumb" method on the parent page
//    this.sendBreadcrumb.emit(breadcrumb);
//  }


//  private getStorageKey(key: string): string {
//    const dt: string | null = localStorage.getItem(key);
//    return dt ? dt : '';
//  }

//}
